import React, {Component} from "react";
import clsx from 'clsx';
import {makeStyles} from '@mui/styles';
import moment from 'moment';
import Dropzone from 'react-dropzone';

import DatePicker from "react-datepicker";
import '../../../assets/css/Supervisor.css';
import "react-datepicker/dist/react-datepicker.css";

import axios from 'axios'

import Sidebar from "../../../components/Sidebar";
import PageHeader from "../../../components/PageHeader";
import TableHeader from "../../../components/TableHeader";
import {
    Card,
    Breadcrumbs,
    RadioGroup,
    TextField,
    Grid,
    Button,
    Radio,
    InputAdornment,
    CircularProgress, CardContent,
} from '@mui/material';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import ModalChangePassword from "../../../components/Modal/modalChangePassword";
import ModalConfirmEdit from "../../../components/Modal/modalConfirmEdit";

import AddAccountant from "../../../components/Modal/modalAddAccountant";
import UploadFile from "../../../components/Modal/modalUploadFile";
import ModalUploadAvatar from "../../../components/Modal/ModalChangeAvatar"
import ModalConfirmDeleteCert from "../../../components/Modal/modalConfirmDeleteCert";
import FilesApi from "../../../services/resource/files";
import UserFile from "../../../services/ob-user/user-file";
// import ModalCropImage from "../../../components/Modal/ModalCropImage"

import SupervisorApi from "../../../services/ob-user/supervisor";
import ProvinceApi from "../../../services/ob-user/province";
import {toast} from "react-toastify";
import PartnerApi from "../../../services/ob-user/partner";

const formatDate = 'DD-MM-YYYY';

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 10,
        height: 10,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
            // backgroundColor: '#1BBDA5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1BBDA5',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 10,
            height: 10,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            // backgroundColor: '#106ba3',
            backgroundColor: '#ea7b22',
        },
    },
});


const renderSex = function (value) {
    switch (value) {
        case '1':
            return 'MALE';
        case '0':
            return 'Nhỏ';
        default:
            return 'Siêu nhỏ';
    }
};


// const renderBusiness = function (business) {
//     switch (business) {
//         case 'COMMERCE_SERVICE':
//             return 'Thương mại - Dịch vụ';
//         case 'MANUFACTURING_MACHINING':
//             return 'Sản xuất - Gia công';
//         default:
//             return 'Xây dựng - Lắp đặt - Đầu tư bất động sản';
//     }
// };

const renderDistrictId = function (districtId) {
    let _district = JSON.parse(localStorage.getItem("district")) ? JSON.parse(localStorage.getItem("district")) : {};
    return _district?.filter(item => item.id === districtId)[0] ? _district?.filter(item => item.id === districtId)[0].name : '';
};

const renderProvinceId = function (provinceId) {
    let _province = JSON.parse(localStorage.getItem("province")) ? JSON.parse(localStorage.getItem("province")) : {};
    return _province?.filter(item => item.id === provinceId)[0] ? _province?.filter(item => item.id === provinceId)[0].name : '';
};

const renderProvince = function () {
    let _province = JSON.parse(localStorage.getItem("province")) ? JSON.parse(localStorage.getItem("province")) : {};
    return _province?.map((item, index) => <option value={item.id}>{item.name}</option>)
};

function formatMoney(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

function StyledRadio(props) {
    const classes = useStyles();
    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
            icon={<span className={classes.icon}/>}
            {...props}
        />
    );
}

const scale = [
    {
        value: "MEDIUM",
        name: "Vừa",
    },
    {
        value: "EXTRASMALL",
        name: "Siêu nhỏ",
    },
    {
        value: "SMALL",
        name: "Nhỏ",
    },

]


class ProfileSupervisor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            onEdit: false,
            inEditing: false,
            showUpload: false,
            update:false,
            dataSupervisor: {},
            partnerDetail: {},
            listProvince: [],
            listDistrict: [],
            AreaSup: [],
            files: [],
            filesCertificate: [],
            modalConfirmDeleteCert: false,
            fileId: null,
            address: '',
            provinceId: 0,
            districtId: 0,
            gender: '',
            identify: '',
            dateIssued: '',
            placeIssued: '',
            placeSupportId: '',
            phoneNum: '',
            email: '',
            job: '',
            expyear: '',
            name: '',
            avatar: '',
            field: [],
            description: "",
            certificate: "",
            modalUploadAvatar: false,

            addressError: false,
            identifyError: false,
            nameError: false,
            placeIssuedError: false,
            dateIssuedError: false,
            sexError: false,
            expError: false,
            provinceIdError: false,
            districtIdError: false,
            placeSupportIdError:false,
            descriptionError: false,
            certificateError: false,
            btnSaveStatus: false,


            showConfirmModal: false,


            loading: false,
            progress: 0,
            confirmCancel: false,

            showModalChangePassword: false,

            fieldSupport: [
                {
                    id: 0,
                    name: "Thương mại - Dịch vụ",
                    checked: false
                },
                {
                    id: 1,
                    name: "Sản xuất",
                    checked: false
                },
                {
                    id: 2,
                    name: "Xây dựng",
                    checked: false
                },
            ],

            header: [
                {
                    id: '123',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'numOfContract',
                    name: "Bằng cấp chứng chỉ",
                    style: {minWidth: 60, textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'status',
                    name: "File bằng cấp chứng chỉ",
                    style: {minWidth: 80, textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {minWidth: 100, textAlign: "center"},
                    sort: false,
                },

            ],
        }
    }

    componentWillMount() {
        this.getSupervisorInfo();
        this.getSupportArea();
        this.getFile();
        this.state.files.forEach(file => URL.revokeObjectURL(file.preview))
    }

    handleShowModalForgotPassword = () => {
        this.setState({showModalChangePassword: true});
    };

    onCloseModalForgotPassword = () => {
        this.setState({showModalChangePassword: false});
    }
    showModalUploadAvatar = () => {
        this.setState({modalUploadAvatar: true})
    }
    modalUploadAvatarClose = () => {
        this.setState({modalUploadAvatar: false});
    }


    getSupportArea(){
        ProvinceApi.supportArea(res => {
            if (res.success === true) {
                this.setState({
                    AreaSup: res.data.content
                })
            }else{

            }
        })
    }

    getDetailPartner(id){
        let payload = {
            id: id
        }
        PartnerApi.getDetail(payload, res =>{
            if(res.success){
                this.setState({
                    partnerDetail: res.data
                }, () => console.log("check>>>>", this.state.partnerDetail.urlImage))
            }
        })
    }

    getSupervisorInfo() {
        SupervisorApi.detailSupervisor(res => {
            if (res.success) {
                this.setState({
                        dataSupervisor: res.data,
                        address: res.data.address,
                        provinceId: res.data.provinceId,
                        districtId: res.data.districtId,
                        gender: res.data.sex,
                        identifycode: res.data.identify,
                        dateIssue: res.data.dateIssued,
                        placeIssue: res.data.placeIssued,
                        placeSupportId: res.data.areaId,
                        job: res.data.job,
                        expyear: res.data.experience,
                        name: res.data.fullName,
                        email: res.data.email,
                        description: res.data.description,
                        certificate: res.data.certificate,
                        field: res.data.fieldSupport != null ? res.data.fieldSupport.split(",") : []
                    }, () => this.getSupportArea()
                );
                this.getDetailPartner(res.data.partnerId);
            } else {

            }
        })
    };

    // getAccountInfo() {
    //     userApi.profile(res => {
    //         if (res.success === true) {
    //             console.log("success>>>>>>", res)
    //             this.setState({
    //                 data: res.data
    //             }, () => {
    //                 this.setState({
    //                     address: this.state.data ? this.state.data.address : "",
    //                     tax: this.state.data ? this.state.data.tax : "",
    //                     identify: this.state.data ? this.state.data.identify : "",
    //                     email: this.state.data ? this.state.data.email : "",
    //                     phone: this.state.data ? this.state.data.phone : "",
    //                     business: this.state.data ? this.state.data.business : "",
    //                     scale: this.state.data ? this.state.data.scale : "",
    //                     revenue: this.state.data ? this.state.data.revenue : "",
    //                     representative: this.state.data ? this.state.data.representative : "",
    //                     position: this.state.data ? this.state.data.position : "",
    //                     representativePhone: this.state.data ? this.state.data.representativePhone : "",
    //                     placeIssued: this.state.data ? this.state.data.placeIssued : "",
    //                     dateIssued: this.state.data ? this.state.data.dateIssued : "",
    //                     sex: this.state.data ? this.state.data.sex : "",
    //                     provinceId: this.state.data ? this.state.data.provinceId : 0,
    //                     districtId: this.state.data ? this.state.data.districtId : 0,
    //
    //                 })
    //             })
    //         } else {
    //             console.log("err >>>>>>", res)
    //         }
    //     })
    // }

    handleChangeTax(val) {
        // console.log(val)
        this.setState({inEditing: true})
        const onlyNums = val.target.value.replace(/[^0-9]/g, '');
        // const onlyNums = val.target.value;
        if (onlyNums.length < 13) {
            this.setState({tax: onlyNums}, () => {
                this.state.tax.length != 0 ? this.setState({taxError: false}) : this.setState({taxError: true});
                this.state.tax.length >= 10 ? this.setState({taxError: false}) : this.setState({taxError: true})
            });
        } else if (onlyNums.length === 13) {
            const number = onlyNums.replace(
                /(\d{2})(\d{4})(\d{4})/,
                '$1$2$3'
            );
            this.setState({tax: onlyNums});
        } else if (onlyNums.length === 14) {
            const number = onlyNums.replace(
                /(\d{2})(\d{4})(\d{5})/,
                '$1$2$3'
            );
            this.setState({tax: onlyNums});
        }
    };

    handleChangeexpyear(val) {
        this.setState({inEditing: true});
        const onlyNums = val.target.value.replace(/[^0-9]/g, '').trim();
        this.setState({expyear: onlyNums})
    };

    handleChangeIdentify(val) {
        // console.log(val)
        this.setState({inEditing: true})
        const onlyNums = val.target.value.replace(/[^0-9]/g, '');
        // const onlyNums = val.target.value;
        if (onlyNums.length < 11) {
            this.setState({identify: onlyNums}, () => {
                this.state.identify.length != 0 ? this.setState({identifyError: false}) : this.setState({identifyError: true});
                this.state.identify.length >= 9 ? this.setState({identifyError: false}) : this.setState({identifyError: true})
            });
        } else if (onlyNums.length === 11) {
            const number = onlyNums.replace(
                /(\d{2})(\d{4})(\d{4})/,
                '$1$2$3'
            );
            this.setState({identify: onlyNums});
        } else if (onlyNums.length === 12) {
            const number = onlyNums.replace(
                /(\d{2})(\d{4})(\d{5})/,
                '$1$2$3'
            );
            this.setState({identify: onlyNums});
        }
    };

    componentDidMount() {
        // this.setState({
        //     onEdit: false,
        //     inEditing: false,
        // });
        document.title = 'Hoàn thiện thông tin cá nhân - Uber Accounting';
        let userInfo  = JSON.parse(localStorage.getItem("ob_cl_userInfo"))
        this.setState({userStatus: userInfo.status, emailSaved: userInfo.email})
    }

    handleSave() {
        let {
            address,
            provinceId,
            districtId,
            gender,
            identify,
            dateIssued,
            placeIssued,
            placeSupportId,
            email,
            expyear,
            name,
            avatar,
            field,
            certificate,
            description
        } = this.state;
        if (address === '') {
            this.setState({addressError: true})
        }
        if (description === '') {
            this.setState({descriptionError: true})
        }
        if (certificate === '') {
            this.setState({certificateError: true})
        }
        if (identify === '') {
            this.setState({identifyError: true})
        }
        if (email === '') {
            this.setState({emailError: true})
        }
        if (name === '') {
            this.setState({nameError: true})
        }
        if (placeIssued === '') {
            this.setState({placeIssuedError: true})
        }
        if (dateIssued === '') {
            this.setState({dateIssuedError: true})
        }
        if (gender === '') {
            this.setState({genderError: true})
        }
        if (placeSupportId ===  0 ||placeSupportId == '' || placeSupportId ===  '0') {
            this.setState({placeSupportIdError: true})
        }
        if (provinceId === 0 || provinceId == '0') {
            this.setState({provinceIdError: true})
        }
        if (districtId === 0) {
            this.setState({districtIdError: true})
        }if (expyear === '') {
            this.setState({expError: true})
        } else {
            let payload = {
                address: address,
                areaId: placeSupportId,
                dateIssued: dateIssued,
                districtId: districtId,
                experience: expyear,
                fullName: name,
                identify: identify,
                placeIssued: placeIssued,
                fieldSupport: field.toString(),
                description: description,
                certificate: certificate,
                provinceId: provinceId,
                sex: gender,
                urlImage: avatar
            }
            this.setState({loading: true}, () => {
                let timer = setInterval(() => {
                    this.tick()
                }, 10);
                setTimeout(() => {
                    clearInterval(timer);
                    this.setState({
                        loading: false,
                    }, () => {
                        SupervisorApi.updateSupervisor(payload, res => {
                            if (res.success) {
                                this.setState({update:true}, () => {
                                    toast.success("Thông tin đã được cập nhật thành công !")
                                })
                                // this.setState({
                                //     onEdit: false,
                                //     inEditing: false,
                                //     btnSaveStatus: false
                                // }, () => this.getSupervisorInfo());
                            } else {
                                // console.log('err: ', res);
                                toast.error("Cập nhật không thành công, vui lòng thử lại sau !")
                            }
                        })
                    });
                }, 1000);
            });
        }
    }

    tick = () => {
        // reset when reaching 100%
        let {progress} = this.state;
        this.setState({
            progress: progress >= 100 ? 0 : progress + 1
        });
    };

    handleReset() {
        this.setState({
            address: '',
            placeSupportId: '',
            dateIssued: '',
            districtId: '',
            expyear: '',
            name: '',
            identify: '',
            placeIssued: '',
            provinceId: '',
            gender: '',
            description: "",
            certificate: "",
        })
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    renderDistrict = (provinceId) => {
        let _district = JSON.parse(localStorage.getItem("district")) ? JSON.parse(localStorage.getItem("district")) : '';
        return _district?.filter(item => item.provinceId == provinceId).map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onChangeDistrict = (e) => {
        this.setState({
            districtId: e.target.value,
            inEditing: true
        })
    };

    uploadCert = (res, file, namefiles) => {
        let payload = {
            fileName: file.name,
            fullName: namefiles,
            storageName: res.storageName,
            destination: res.destination
        }
        FilesApi.supervisorUploadCertificate(payload, res => {
            if (res.success) {
                toast.success("Cập nhật chứng chỉ thành công!")
                this.getFile()
            } else {
                toast.error("Cập nhật chứng chỉ không thành công!")
            }
        })
    };

    getFile = () => {
        UserFile.getAll(res => {
            if(res.success) {
                this.setState({filesCertificate: res.data})
            }
        })
    }

    modalUploadAvatarClose = () => {
        this.setState({modalUploadAvatar: false});
    }
    modalCropClose = () => {
        this.setState({showModalCrop: false});
    }

    showModalUploadAvatar = () => {
        this.setState({modalUploadAvatar: true})
    }

    onDeleteCert = (item) => {
        this.setState({fileId: item.id, modalConfirmDeleteCert: true})
    }

    onCheckSupport = (item) => {
        let {field} = this.state
        if (field.find(name => name === item.name) === item.name) {
            return true
        } else {
            return false
        }
    }

    onHandleChooseSupport = (val, item) => {
        let {field, fieldSupport} = this.state
        if(val.target.checked) {
            field.push(val.target.value)
        }else{
            field.splice(field.indexOf(val.target.value),1)
        }
        fieldSupport.map(_item => {
            if (_item.name == item.name){
                _item.checked = val.target.checked
            }
        })
        this.setState({
            field: field,
            fieldSupport,
            inEditing: true
        })

    }

    render() {
        let profile = JSON.parse(localStorage.getItem("ob_cl_userDetail"));
        let info = JSON.parse(localStorage.getItem("ob_cl_userInfo"));
        const {files, address, identify, email, business, scale, revenue, representative, position, representativePhone, dataSupervisor, partnerDetail, tax, placeIssued, dateIssued, sex, provinceId, districtId} = this.state;

        return (
            <div>
                <div className="container">
                    <div className="row">
                        {/*<Sidebar activeClass="profile"/>*/}
                        {this.state.update || this.state.userStatus == "WAIT_CONFIRM_EMAIL"?
                            <div className="tab-content col-12 min-w100">
                                <div variant="outlined" className='mb-4 p-2 card border-color'>
                                    <div
                                        className='kt-margin-b-20 flex-column justify-content-center align-center p-3'
                                        style={{background: '#F1CDCB'}}>
                                        <h6 className="line-height-30">Uber Accounting đã gửi một email xác thực thông tin
                                            đến hòm thư {this.state.emailSaved} của bạn. Bạn hãy truy cập vào Email để xác nhận thông tin và
                                            tiếp tục sử dụng hệ thống.</h6>
                                        <h6 className="mt-2"><b>Xin cảm ơn!</b></h6>
                                    </div>
                                </div>
                            </div>:
                            <div className="col-md-12 tab-content">
                                <div variant="outlined" className='mb-4 p-2 card border-color'>
                                    {/*<CardContent>*/}
                                    {/*    <div className='d-flex justify-content-center col-12 mt-3' style={{height: 120}} >*/}
                                    {/*        <span className='size-text-header'>*/}
                                    {/*            {this.state.onEdit ? 'Chỉnh sửa thông tin cá nhân' : 'Thông tin cá nhân'}*/}
                                    {/*        </span>*/}
                                    {/*    </div>*/}
                                    {/*//**********************************************Thong tin doanh nghiep****************************************************************************************************/}
                                    <div className='d-flex justify-content-start col-12 mt-3' style={{height: 120}}>
                                        <div className='col-4 d-flex ml-2'>
                                            <span className='text-header-profile'>Thông tin doanh nghiệp</span>
                                        </div>
                                        <div className='col-4'>
                                            <img
                                                src={partnerDetail.urlImage ? partnerDetail?.urlImage :`https://www.uhy.vn/sites/default/files/uhyco.ltd_.jpg`}
                                                // src={data.urlImagePartner ? data.urlImagePartner : "http://ecorau.com/images/logo_mail.png"}
                                                className='mh-100 mw-100 m-2'
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4 font-14 ml-4 mr-4">
                                        <div className='row kt-margin-b-20'>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Tên doanh nghiệp</span>
                                            </div>
                                            <div
                                                className="pl-0 col-md-4 col-lg-4 col-sm-8 font-weight-bold kt-margin-b-10-tablet-and-mobile">
                                                {partnerDetail?.fullName?.toUpperCase()}
                                            </div>


                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Mã số thuế</span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 font-weight-bold kt-margin-b-10-tablet-and-mobile">
                                                {info.tax}
                                            </div>


                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">
                                                    Số điện thoại
                                                </span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                {info.phonePartner}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Email </span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                {info.emailPartner}
                                            </div>


                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Tỉnh/Thành phố</span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                {renderProvinceId(info.provinceIdPartner)}
                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Quận/Huyện</span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                {renderDistrictId(info.provinceIdPartner)}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Địa chỉ </span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                {info.addressPartner}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 col-md-6 col-lg-6 col-sm-12 kt-margin-b-10-tablet-and-mobile">
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/********************************Thong tin ca nhan****************************************************/}
                                <div variant="outlined" className='mb-4 p-2 card border-color'>
                                    <div className='d-flex justify-content-center col-12 mt-3 kt-margin-b-20'>
                                        <div className='d-block col-4 ml-2'>
                                            <span className='text-header-profile'>Thông tin cá nhân</span>
                                            <div>
                                                <label style={{color: 'red', fontSize: 13}}>Thông tin cá nhân sẽ không bị công khai</label>
                                            </div>
                                        </div>
                                        <div className='col-4'>
                                            <img
                                                // src={`https://www.uhy.vn/sites/default/files/uhyco.ltd_.jpg`}
                                                // src={'data:image/jpeg;base64,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'}
                                                // src={files.length !== 0 ? files[0].preview : dataSupervisor.urlImage}
                                                src={dataSupervisor.urlImage?dataSupervisor.urlImage: "https://www.w3schools.com/howto/img_avatar.png"}
                                                className='img-supervisor'
                                                onClick={this.showModalUploadAvatar}
                                            />
                                        </div>
                                        <div className='col-4'>

                                        </div>
                                    </div>

                                    <div className="mt-4 font-14 ml-4 mr-4">
                                        <div className='row kt-margin-b-20'>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Họ và tên
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <input type="text"
                                                       className={this.state.nameError ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                       placeholder='Nhập họ và tên'
                                                       value={this.state.name}
                                                       maxLength={50}
                                                       onChange={(val) => this.setState({
                                                           name: val.target.value.trimLeft(),
                                                           inEditing: true
                                                       }, () => {
                                                           this.state.name.length == 0 ? this.setState({
                                                               nameError: true,
                                                               btnSaveStatus: true
                                                           }) : this.setState({nameError: false, btnSaveStatus: false})
                                                       })}
                                                />
                                                {this.state.nameError?<span className="pl-1 color-red size-font-err-date">Vui lòng nhập họ và tên !</span>:<div/>}
                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Vị trí công việc</span>
                                            </div>
                                            <div
                                                className={this.state.onEdit ?"pl-3 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile":"pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile"}>
                                                {profile.type}
                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">
                                                Số điện thoại
                                            </span>
                                            </div>
                                            <div
                                                className={this.state.onEdit ?"pl-2 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile":"pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile"}>
                                                {profile.phone}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span
                                                className="text-black-50">Số năm kinh nghiệm
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <input type="text"
                                                       className={this.state.expError ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                       placeholder="Nhập số năm"
                                                       value={this.state.expyear}
                                                       maxLength={2}
                                                    // aria-label="Username"
                                                    // aria-describedby="basic-addon1"
                                                       onChange={(val) => this.setState({
                                                           expyear: val.target.value.trim().replace(/[^0-9]/g, ''),
                                                           inEditing: true
                                                       }, () => {
                                                           this.state.expyear.length === 0 || this.state.expyear == '00' || this.state.expyear == '0' ? this.setState({
                                                               expError: true,
                                                               btnSaveStatus: true
                                                           }) : this.setState({expError: false, btnSaveStatus: false})
                                                       })}
                                                />
                                                {this.state.expError?<span className="pl-1 color-red size-font-err-date">Vui lòng nhập số năm !</span>:<div/>}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Email </span>
                                            </div>
                                            <div
                                                className={this.state.onEdit ?"pl-2 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile":"pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile"}>
                                                {info.email}
                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Khu vực hỗ trợ
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">

                                                <select
                                                    className={this.state.placeSupportIdError?"form-control border-input-error kt-input pd-4-input hei-input":"form-control kt-input pd-4-input hei-input"}
                                                    value={this.state.placeSupportId}
                                                    defaultValue={0}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            placeSupportId: e.target.value,
                                                            placeSupportIdError:false,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value={0}>Chọn Tỉnh/Thành Phố</option>
                                                    {this.state.AreaSup?.map((item) => (<option value={item.id}>{item.name}</option>))}
                                                </select>
                                                {this.state.placeSupportIdError?<span className="pl-1 color-red size-font-err-date">Vui lòng chọn khu vực hỗ trợ !</span>:<div/>}
                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Chứng chỉ/Bằng
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <textarea
                                                    placeholder="Nhập các chứng chỉ hoặc bằng đã đạt được(Thời gian: Tên chứng chỉ/Bằng)"
                                                    value={this.state.description}
                                                    rows={3}
                                                    className={this.state.descriptionError ? "form-control border-input-error shadow-none p-2" : "form-control shadow-none p-2"}
                                                    style={{resize: 'none', fontSize: 14}}
                                                    maxLength={500}
                                                    onChange={(e) => {
                                                        this.setState({description: e.target.value}, () => {
                                                            this.state.description.length === 0 ? this.setState({
                                                                descriptionError: true,
                                                                btnSaveStatus: true
                                                            }) : this.setState({
                                                                descriptionError: false,
                                                                btnSaveStatus: false
                                                            })
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Mô tả kinh nghiệm
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <textarea
                                                    placeholder="Nhập kinh nghiệm làm việc"
                                                    value={this.state.certificate}
                                                    rows={3}
                                                    className={this.state.certificateError ? "form-control border-input-error shadow-none p-2" : "form-control shadow-none p-2"}
                                                    style={{resize: 'none', fontSize: 14}}
                                                    maxLength={500}
                                                    onChange={(e) => {
                                                        this.setState({certificate: e.target.value}, () => {
                                                            this.state.certificate.length === 0 ? this.setState({
                                                                certificateError: true,
                                                                btnSaveStatus: true
                                                            }) : this.setState({
                                                                certificateError: false,
                                                                btnSaveStatus: false
                                                            })
                                                        })
                                                    }}
                                                />
                                            </div>

                                            <div className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Giới tính
                                                <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <div className='d-flex col-12'>
                                                    <div className="form-check col-6 ">
                                                        <input className="form-check-input"
                                                               type="radio"
                                                               name="femaleRadios"
                                                               id="female"
                                                               value="FEMALE"
                                                               onClick={(val) => {
                                                                   this.setState({
                                                                       gender: val.target.value,
                                                                       inEditing: true,
                                                                       genderError: false
                                                                   })
                                                               }}
                                                               checked={this.state.gender === 'FEMALE'}
                                                        />
                                                        <label className="form-check-label" htmlFor="exampleRadios1"> Nữ </label>
                                                    </div>
                                                    <div className="form-check col-6">
                                                        <input className="form-check-input border-input-error"
                                                               type="radio"
                                                               name="maleRadios"
                                                               id="male"
                                                               value="MALE"
                                                               onClick={(val) => {
                                                                   this.setState({
                                                                       gender: val.target.value,
                                                                       inEditing: true,
                                                                       genderError: false
                                                                   })
                                                               }}
                                                               checked={this.state.gender === 'MALE'}
                                                        />
                                                        <label className="form-check-label" htmlFor="exampleRadios1">
                                                            Nam
                                                        </label>
                                                    </div>
                                                </div>
                                                {this.state.genderError?<span className="pl-1 color-red size-font-err-date">Bạn chưa chọn giới tính !</span>:<div/>}
                                            </div>
                                            <div className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">CMND/CCCD
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <input type="text"
                                                       className={this.state.identifyError ? "form-control  border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                       placeholder="Nhập số CMND/CCCD"
                                                       value={this.state.identify}
                                                    // aria-label="Username"
                                                       maxLength={12}
                                                    // aria-describedby="basic-addon1"
                                                       onChange={(val) => this.setState({
                                                           identify: val.target.value.trim().replace(/[^0-9]/g, ''),
                                                           inEditing: true
                                                       }, () => {
                                                           this.state.identify.length === 0 || this.state.identify.length < 9 ? this.setState({
                                                               identifyError: true,
                                                               btnSaveStatus: true
                                                           }) : this.setState({
                                                               identifyError: false,
                                                               btnSaveStatus: false
                                                           })
                                                       })}
                                                />
                                                {this.state.identifyError?<span className="pl-1 color-red size-font-err-date">Số CMND/CCCD trống hoặc sai định dạng !</span>:<div/>}

                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Tỉnh/Thành phố
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">

                                                <select
                                                    className={this.state.provinceIdError?"form-control border-input-error kt-input pd-4-input hei-input":"form-control kt-input pd-4-input hei-input"}
                                                    value={provinceId}
                                                    defaultValue={0}
                                                    onChange={(e) => {
                                                        let _district = JSON.parse(localStorage.getItem("district")) ? JSON.parse(localStorage.getItem("district")) : '';
                                                        let _disfilter = _district?.filter(item => item.provinceId == e.target.value);
                                                        this.setState({
                                                            provinceId: e.target.value,
                                                            districtId: _disfilter[0]?.id,
                                                            provinceIdError:false,
                                                            inEditing: true
                                                        })
                                                    }}
                                                    // onSelect={() => this.onChangeDistrict}
                                                >
                                                    <option value={0}>Chọn Tỉnh/Thành Phố</option>
                                                    {renderProvince()}
                                                </select>
                                                {this.state.provinceIdError?<span className="pl-1 color-red size-font-err-date">Vui lòng chọn Tỉnh/Thành phố !</span>:<div/>}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-sm-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Ngày cấp
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">

                                                <DatePicker
                                                    className={this.state.dateIssuedError?"w-autoerr react-datepicker-wrapper kt-input pd-4-input hei-input":"w-auto react-datepicker-wrapper kt-input pd-4-input hei-input"}
                                                    // onChangeRaw={this.handleDateChangeRaw}
                                                    selected={this.state.dateIssued === '' ? "" : new Date(this.state.dateIssued)}
                                                    // value={moment(this.state.dateIssue, 'YYYY-MM-DD')}
                                                    maxDate={new Date()}
                                                    // value={this.state.dateIssue}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            let value = moment(date).format("YYYY-MM-DD").toString();
                                                            try {
                                                                this.setState({
                                                                    dateIssued: value == "Invalid date" ? null :moment(value).format("YYYY-MM-DD"),
                                                                    inEditing: true,
                                                                    dateIssuedError:false
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                                {this.state.dateIssuedError?<span className="pl-1 color-red size-font-err-date">Vui lòng nhập ngày cấp !</span>:<div/>}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Quận/Huyện
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">

                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={districtId}
                                                    onChange={this.onChangeDistrict}
                                                >
                                                    {this.renderDistrict(provinceId)}
                                                </select>

                                            </div>
                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4  kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Nơi cấp
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">

                                                <input type="text"
                                                       className={this.state.placeIssuedError ? "form-control border-input-error kt-input pd-4-input hei-input" : "form-control kt-input pd-4-input hei-input"}
                                                       placeholder="Nhập nơi cấp"
                                                       value={this.state.placeIssued}
                                                    // aria-label="Username"
                                                       maxLength={50}
                                                    // aria-describedby="basic-addon1"
                                                       onChange={(val) => this.setState({
                                                           placeIssued: val.target.value.trimLeft(),
                                                           inEditing: true
                                                       }, () => {
                                                           this.state.placeIssued.length === 0 ? this.setState({
                                                               placeIssuedError: true,
                                                               btnSaveStatus: true
                                                           }) : this.setState({
                                                               placeIssuedError: false,
                                                               btnSaveStatus: false
                                                           })
                                                       })}
                                                />
                                                {this.state.placeIssuedError?<span className="pl-1 color-red size-font-err-date">Vui lòng nhập nơi cấp !</span>:<div/>}
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Địa chỉ
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">

                                                <input type="text"
                                                       className={this.state.addressError ? "form-control border-input-error kt-input pd-4-input hei-input " : "form-control kt-input pd-4-input hei-input"}
                                                       placeholder="Nhập địa chỉ"
                                                       value={address}
                                                       maxLength={100}
                                                    // aria-label="Username"
                                                    // aria-describedby="basic-addon1"
                                                       onChange={(val) => this.setState({
                                                           address: val.target.value.trimLeft(),
                                                           inEditing: true
                                                       }, () => {
                                                           this.state.address.length === 0 ? this.setState({
                                                               addressError: true,
                                                               btnSaveStatus: true
                                                           }) : this.setState({
                                                               addressError: false,
                                                               btnSaveStatus: false
                                                           })
                                                       })}
                                                />
                                                {this.state.addressError?<span className="pl-1 color-red size-font-err-date">Vui lòng nhập địa chỉ !</span>:<div/>}

                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-4 kt-margin-b-10-tablet-and-mobile">
                                            <span className="text-black-50">Lĩnh vực
                                            <span className={'color-red d-inline'}>*</span></span>
                                            </div>
                                            <div
                                                className="pl-0 pb-2 col-md-4 col-lg-4 col-sm-8 kt-margin-b-10-tablet-and-mobile">
                                                <div className='col-12'>

                                                    {this.state.fieldSupport.map(item => {
                                                        return (
                                                            <div className="form-check">
                                                                <input className="form-check-input" type="checkbox"
                                                                       value={item.name}
                                                                       onClick={(val) => {
                                                                           this.onHandleChooseSupport(val, item)}}
                                                                       checked={this.onCheckSupport(item)}
                                                                />
                                                                <label className="form-check-label"
                                                                       htmlFor="exampleRadios1">
                                                                    {item.name}
                                                                </label>
                                                            </div>
                                                        )
                                                    })}

                                                    {/*<div className="form-check ">*/}
                                                    {/*    <input className="form-check-input" type="checkbox"*/}
                                                    {/*           value="Thương mại - Dịch vụ - Đầu tư tài chính"*/}
                                                    {/*           onClick={(val) => {*/}
                                                    {/*               this.onSelect(val)}}*/}
                                                    {/*           // checked={this.state.field.find(item => item === "Thương mại - Dịch vụ - Đầu tư tài chính") === 'Thương mại - Dịch vụ - Đầu tư tài chính'}*/}
                                                    {/*    />*/}
                                                    {/*    <label className="form-check-label"*/}
                                                    {/*           htmlFor="exampleRadios1">*/}
                                                    {/*        Thương mai - dịch vụ*/}
                                                    {/*    </label>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="form-check">*/}
                                                    {/*    <input className="form-check-input" type="checkbox"*/}
                                                    {/*           value="2"*/}
                                                    {/*           onClick={(val) => {*/}
                                                    {/*               this.onSelect(val)}}*/}
                                                    {/*           checked={this.state.field === '2'}*/}
                                                    {/*    />*/}
                                                    {/*    <label className="form-check-label"*/}
                                                    {/*           htmlFor="exampleRadios1">*/}
                                                    {/*        Sản xuất*/}
                                                    {/*    </label>*/}
                                                    {/*</div>*/}
                                                    {/*<div className="form-check">*/}
                                                    {/*    <input className="form-check-input" type="checkbox"*/}
                                                    {/*           value="3"*/}
                                                    {/*           onClick={(val) => {*/}
                                                    {/*               this.onSelect(val)}}*/}
                                                    {/*           checked={this.state.field === '3'}*/}
                                                    {/*    />*/}
                                                    {/*    <label className="form-check-label"*/}
                                                    {/*           htmlFor="exampleRadios1">*/}
                                                    {/*        Xây dựng*/}
                                                    {/*    </label>*/}
                                                    {/*</div>*/}
                                                </div>
                                            </div>

                                            <div
                                                className="pl-0 pb-2 pr-0 col-md-2 col-lg-2 col-sm-2 kt-margin-b-10-tablet-and-mobile">
                                                <span className="text-black-50">Mật khẩu</span>
                                            </div>
                                            <div
                                                className={this.state.onEdit ?"pl-2":"pl-0"}>
                                                **********
                                            </div>
                                            <div
                                                className="pb-2 col-sm-2 change-password"
                                                onClick={() => this.handleShowModalForgotPassword()}
                                            >
                                                Đổi mật khẩu
                                            </div>
                                        </div>
                                    </div>

                                    <Grid container spacing={2} justify={"flex-center"}>
                                        <Grid item xs={12} sm={12} md={12} className='text-center'>
                                            {this.state.loading &&
                                            <Button variant="outlined" color="primary"
                                                    className='mr-3'
                                                    style={{textTransform: 'initial'}}
                                            >
                                                <CircularProgress size={20} variant="determinate"
                                                                  value={this.state.progress}/>
                                            </Button>}
                                            {!this.state.loading &&
                                            <Button disabled={this.state.btnSaveStatus} variant="contained" color="primary"
                                                    className='mr-3'
                                                    style={{textTransform: 'initial'}}
                                                    onClick={() => this.handleSave()}
                                            >
                                                Lưu
                                            </Button>}
                                            <Button variant="outlined" style={{textTransform: 'initial'}}
                                                    onClick={() => this.handleReset()}
                                            >
                                                Nhập lại
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    {/*</CardContent>*/}
                                </div>

                                {/*********************************************************************************************************************************??*/}
                                <div variant="outlined" className='p-2 mb-5 card border-color'>
                                    {/*<CardContent>*/}
                                    <div className='d-flex justify-content-center col-12 mt-3' style={{height: 120}}>
                                        <div className='col-8 d-flex ml-2'>
                                            <span className='text-header-profile'>Hồ sơ cá nhân</span>
                                        </div>
                                        <div className='col-4'>
                                            <div className='d-flex justify-content-end'>
                                                {/*<Dropzone*/}
                                                {/*    getUploadParams={() => ({url: 'https://httpbin.org/post'})} // test*/}
                                                {/*    accept="image/*"*/}
                                                {/*    onDrop={acceptedFiles => {*/}
                                                {/*        console.log(acceptedFiles)*/}
                                                {/*        this.setState({*/}
                                                {/*            filesCertificate: acceptedFiles.map(file => Object.assign(file, {*/}
                                                {/*                preview: URL.createObjectURL(file)*/}
                                                {/*            }))*/}
                                                {/*        })*/}
                                                {/*    }*/}
                                                {/*    }*/}
                                                {/*>*/}
                                                {/*    {({getRootProps, getInputProps}) => (*/}
                                                {/*        <span title='Upload file'>*/}
                                                {/*            <span {...getRootProps()}>*/}
                                                {/*                <input {...getInputProps()} />*/}
                                                <button className="btn btn-primary" onClick={() => this.setState({showUpload: true})}>
                                                    Upload
                                                </button>
                                                {/*            </span>*/}
                                                {/*        </span>*/}
                                                {/*    )}*/}
                                                {/*</Dropzone>*/}

                                            </div>
                                        </div>
                                    </div>

                                    <table className="table mt-5 mb-5 table-striped table-data table-bordered ">
                                        <thead>
                                        <TableHeader header={this.state.header} clickSort={(data) => {
                                        }}/>
                                        </thead>
                                        <tbody>
                                        {this.state.filesCertificate.length !== 0
                                            ? this.state.filesCertificate.map((item, index) =>
                                                <tr>
                                                    <th scope="row" className='text-center'>{index + 1}</th>
                                                    <td className='text-center'>{item.fullName}</td>
                                                    <td className='text-center'>{item.fileName}</td>
                                                    <td className='text-center'>
                                                        <div>
                                                            <button className="btn" title="Xóa chứng chỉ"
                                                                    onClick={() => this.onDeleteCert(item)}>
                                                                <i className='ti-trash'/>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )

                                            : <tr>
                                                <td colSpan={4}><div><span><h6>Không có dữ liệu</h6></span></div></td>

                                                {/*<th scope="row" className='text-center'>1</th>*/}
                                                {/*<td className='text-center'>Chứng chỉ thuế</td>*/}
                                                {/*<td className='text-center'>anh</td>*/}
                                                {/*<td className='text-center'>*/}
                                                {/*    <div>*/}
                                                {/*        <button className="btn" title="Xóa chứng chỉ"*/}
                                                {/*                onClick={this.onDeleteCert}>*/}
                                                {/*            <i className='ti-trash'/>*/}
                                                {/*        </button>*/}
                                                {/*    </div>*/}
                                                {/*</td>*/}
                                            </tr>

                                        }

                                        </tbody>
                                    </table>


                                    {/*{this.state.confirmCancel &&*/}
                                    {/*<Dialog*/}
                                    {/*    open={true}*/}
                                    {/*    onClose={() => this.setState({confirmCancel: false})}*/}
                                    {/*>*/}
                                    {/*    <DialogTitle>Thông tin đã thay đổi, bạn có chắc muốn hủy ?</DialogTitle>*/}
                                    {/*    <DialogActions>*/}
                                    {/*        <Button*/}
                                    {/*            style={{textTransform: 'initial'}}*/}
                                    {/*            color="primary"*/}
                                    {/*            onClick={() => this.setState({*/}
                                    {/*                confirmCancel: false,*/}
                                    {/*                inEditing: false*/}
                                    {/*            }, () => this.handleCancel())}*/}
                                    {/*        >*/}
                                    {/*            Có*/}
                                    {/*        </Button>*/}
                                    {/*        <Button*/}
                                    {/*            color="primary"*/}
                                    {/*            style={{textTransform: 'initial'}}*/}
                                    {/*            onClick={() => this.setState({confirmCancel: false})}*/}
                                    {/*        >*/}
                                    {/*            Không*/}
                                    {/*        </Button>*/}
                                    {/*    </DialogActions>*/}
                                    {/*</Dialog>}*/}
                                    {/*</CardContent>*/}
                                </div>
                                <ModalChangePassword show={this.state.showModalChangePassword}
                                                     onHideModal={this.onCloseModalForgotPassword}/>
                                <ModalConfirmEdit show={this.state.confirmCancel}
                                                  onHide={() => this.setState({confirmCancel: false})}
                                                  handleCancel={
                                                      () => this.setState({
                                                          confirmCancel: false,
                                                          inEditing: false
                                                      }, () => this.handleCancel())
                                                  }
                                />
                                {this.state.showUpload && <UploadFile show={this.state.showUpload}
                                                                      uploadSuccess={this.uploadCert}
                                                                      onHide={() => this.setState({showUpload: false}, () => this.getFile())}/>}
                            </div>}
                    </div>
                </div>
                <ModalUploadAvatar show={this.state.modalUploadAvatar}
                                   onHide={this.modalUploadAvatarClose}
                                   updateSuccess={(item)=> {
                                       this.setState({modalUploadAvatar: false, avatar:item})
                                       this.getSupervisorInfo()
                                   }}/>
                <ModalConfirmDeleteCert show={this.state.modalConfirmDeleteCert}
                                        onHide={() => this.setState({modalConfirmDeleteCert: false})}
                                        fileId={this.state.fileId}/>
                {/*<ModalCropImage show={this.state.showModalCrop} onHide={this.modalCropClose}*/}
                {/*                   customerId={1}/>*/}
            </div>
        );
    }
}

export default ProfileSupervisor
